<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span id="basic-addon1" class="input-group-text"><i class="fa fa-search" /></span>
          </div>
          <multiselect id="land_title" v-model="selectedTitle" v-validate="'required'" :clear-on-select="true" :close-on-select="true" :hide-selected="true" :internal-search="false" :limit="2" :max-height="200" :multiple="false" :options="landTitles" :searchable="true" :show-no-results="false" label="land_title" name="land_title" class="form-control" placeholder="Search Land Title" track-by="id" @search-change="getLandTitles" @input="selectLandTitle">
            <template slot="singleLabel" slot-scope="props">
              <div class="option__desc">
                <div class="option__desc">
                  <h6>{{ props.option.case_number }}</h6>
                </div>
              </div>
            </template>
            <template slot="option" slot-scope="props">
              <div class="option__desc">
                <div class="option__desc">
                  <h6>{{ props.option.case_number }}</h6>
                  <h6>{{ props.option.description }}</h6>
                </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>
    </div>

    <div id="title_heading" class="row">
      <div class="col-12">
        <div class="card-body">
          <div class="row m-b-0">
            <div class="col-lg-12">
              <div class="row m-b-0">
                <div class="col-lg-3 col-md-6">
                  <div class="d-flex align-items-center">
                    <div>
                      <h3 class="font-medium m-b-0">
                        {{ title.case_number }}
                      </h3>
                      <span>Case Number</span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-6">
                  <div class="d-flex align-items-center">
                    <div>
                      <h3 class="font-medium m-b-0">
                        {{ title.resolver.org.name }}
                      </h3>
                      <span>Facilitator</span>
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 col-md-6">
                  <div class="d-flex align-items-center">
                    <div>
                      <h3 class="font-medium m-b-0">
                        {{ title.owner.name }}
                      </h3>
                      <span>Owner</span>
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 col-md-6">
                  <div class="d-flex align-items-center">
                    <div>
                      <h3 class="font-medium m-b-0">
                        <a v-if="title" target="_blank" :href="this.$BORLAUG + '/address/' + title.address">{{ title.address | truncate(10, '...') }}</a>
                      </h3>
                      <span>Blockchain Contract Address</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="title_content" class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body card-blue">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group row">
                  <label class="col-sm-4 text-right control-label col-form-label" for="description">Facilitated By</label>
                  <div class="col-sm-8 text-left">
                    <input id="case_number" class="form-control" name="case_number" type="text" :value="title.resolver.user.first_name + ' ' + title.resolver.user.last_name" disabled>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-4 text-right control-label col-form-label" for="description">Description</label>
                  <div class="col-sm-8 text-left">
                    <textarea id="description" class="form-control" name="description" :value="title.description" disabled />
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-4 text-right control-label col-form-label" for="coords">Coordinates</label>
                  <div class="col-sm-8 text-left">
                    <input id="coords" class="form-control" name="coords" type="text" :value="title.coords.geometry.coordinates" disabled>
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-sm-12">
                    <label class="control-label col-form-label">Notes</label>
                    <document-editor :editor-size="'SMALL'" :editor-disabled="true" :value="title.notes" />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div id="map" class="card-body card-blue" />
              </div>
            </div>

            <hr>

            <div class="row m-t-10">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-6">
                    <label class="control-label">Primary Witnesses</label>
                  </div>
                </div>
              </div>

              <div class="col-md-12 m-t-10 table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Witness Name</th>
                      <th>Address</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="title.witnesses.length === 0" class="text-center">
                      <td colspan="4" class="font-weight-bold">
                        No Witnesses Present
                      </td>
                    </tr>
                    <tr v-for="(w, index) in title.witnesses" v-if="title.witnesses.length > 0" :key="index">
                      <td>{{ index+1 }}</td>
                      <td>{{ w.name }}</td>
                      <td>{{ w.address }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <hr>

            <div class="row m-t-10">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-6">
                    <label class="control-label">Uploaded Documents</label>
                  </div>
                </div>
              </div>

              <div class="col-md-12 m-t-10 table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Document</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="title.attachments.length === 0" class="text-center">
                      <td colspan="4" class="font-weight-bold">
                        No Documents Uploaded
                      </td>
                    </tr>
                    <template v-if="title.attachments.length > 0">
                      <tr v-for="(a, index) in title.attachments" :key="index">
                        <td>{{ index+1 }}</td>
                        <td>
                          <a href="javascript:void(0)" @click="downloadFile(index)">{{ a.filename }}</a>
                        </td>
                        <td>{{ a.description }}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>

            <hr>

            <div class="row m-t-10">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-6">
                    <label class="control-label">Title Attributes</label>
                  </div>
                </div>
              </div>
              <div class="col-md-12 m-t-10 table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Attribute Name</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="title.attributes.length === 0" class="text-center">
                      <td colspan="4" class="font-weight-bold">
                        No Attributes Added
                      </td>
                    </tr>
                    <tr v-for="(p, index) in title.attributes" :key="index">
                      <td>{{ index+1 }}</td>
                      <td>{{ p.name }}</td>
                      <td>{{ p.description }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';
import DocumentEditor from '../common/DocumentEditor';

export default {
  name: 'Search',
  components: { Multiselect, DocumentEditor },
  data() {
    return {
      $BORLAUG: this.$BORLAUG,
      landTitles: [],
      selectedTitle: null,
      title: {
        id: null,
        case_number: null,
        description: null,
        coords: {
          geometry: { coordinates: [] }
        },
        owner: {},
        resolver: {
          org: {},
          user: {}
        },
        notes: null,
        witnesses: [],
        attachments: [],
        attributes: [],
        address: '',
        txHash: null
      },
      map: null,
      tileLayer: null,
      marker: null,
      layers: []
    };
  },
  computed: {
    ...mapGetters(['currentUser'])
  },
  methods: {
    initMap() {
      this.map = L.map('map').setView([38.63, -90.23], 12);
      this.tileLayer = L.tileLayer(
        'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        {
          maxZoom: 18,
          attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }
      );
      this.tileLayer.addTo(this.map);
      const jsonLayer = L.geoJson(this.title.coords, { color: 'green' });
      jsonLayer.addTo(this.map);
      this.map.fitBounds(jsonLayer.getBounds());
    },
    async getLandTitles(searchText) {
      try {
        const response = await this.$api.get('/land-title', {
          params: {
            searchText
          }
        });
        this.landTitles = response.data;
      } catch (e) {
        console.error(e);
      }
    },
    selectLandTitle(title) {
      this.selectedTitle.id = title.id;
      this.getLandTitleDetails(this.selectedTitle.id);
    },
    async getLandTitleDetails(titleid) {
      if (this.map) {
        this.map.remove();
      }
      const response = await this.$api.get(`/land-title/${titleid}`);
      this.title = response.data;
      document.getElementById('title_heading').style.display = 'block';
      document.getElementById('title_content').style.display = 'block';

      this.initMap();
    },
    async downloadFile(index) {
      const filepath = this.title.attachments[index].filepath;
      const filename = this.title.attachments[index].filename;
      const response = await this.$api.get('/land-title/signedUrl', {
        params: {
          filepath,
          filename,
          type: 'read'
        }
      });

      console.log(filename);

      const element = document.createElement('a');
      element.setAttribute('href', response.data.url);
      element.setAttribute('download', filename);

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    }
  }
}
</script>

<style scoped>
#map {
  width: 100%;
  height: 500px;
}
#title_heading,
#title_content {
  display: none;
}
.multiselect__content-wrapper {
  z-index: 1100;
}
/*.multiselect__content-wrapper {*/
/*    z-index: 1100 !important;*/
/*}*/
</style>
